import axios from '../request/http';
import { toFormData } from '../common/descriptions'

const info = {
    // 话题修改状态
    changeStatus(params) {
        return axios.get("service-article/topic/changeStatus", { params });
    },
    // 乡村信息列表
    infoList(params) {
        return axios.get("/hemei-admin/villageInfo/pageList", { params });
    },
    // 新增乡村
    addVillage(data) {
        return axios.post("/hemei-admin/villageInfo/addVillage", data);
    },
    // 获取城市列表
    getCityList(params) {
        return axios.get("/service-app/village/children/areaId", { params });
    },
    // 修改乡村状态
    updStatus(data) {
        return axios.post("/hemei-admin/villageInfo/updStatus", toFormData(data));
    },
    // 乡村详情
    detail(id) {
        return axios.get("/hemei-admin/villageInfo/detail/" + id);
    },
    // 升级为电商管理员
    updManageType(data) {
        return axios.post("/hemei-admin/villageInfo/updManageType", toFormData(data));
    },
    // 重置管理员密码
    updManagePwd(data) {
        return axios.post("/hemei-admin/villageInfo/updManagePwd", toFormData(data));
    },
    // 获取乡村申请审核列表
    processList(params) {
        return axios.get("/hemei-admin/villageApplyInfo/getVillageApplyInfoPage", { params });
    },
    // 乡村申请审核
    applyProcess(data) {
        return axios.post("/hemei-admin/villageApplyInfo/updStatus", toFormData(data));
    },
    // 获取乡村服务需求广场列表
    needServiceList(params) {
        return axios.get("/hemei-admin/villageJob/getJobPage", { params });
    },
    // 更改状态
    updJobStatus(data) {
        return axios.post("/hemei-admin/villageJob/updJobStatus", toFormData(data));
    },
    // 管理员查询用户的所有文章列表 articleType文章类型 0 常规 1 党政
    getGovernmentList(params) {
        return axios.get("/service-article/article/queryAllList", { params });
    },
    // 用户删除文章
    deleteArticle(params) {
        return axios.get("/service-article/article/delete", { params });
    },
    // 新增或修改文章
    addArticle(data) {
        return axios.post("/service-article/article/create", data);
    },
    // 用户撤回文章（下架：只有绑定用户才可以下架）
    withdrawArticle(params) {
        return axios.get("/service-article/article/withdraw", { params });
    },

    // VR设置
    updVr(data) {
        return axios.post("/hemei-admin/villageInfo/updVr", toFormData(data));
    },
    // 开通、关闭电商服务
    updEcommerce(data) {
        return axios.post("/hemei-admin/villageInfo/updEcommerce", toFormData(data));
    },
    // 乡村信息列表
    pageList(params) {
        return axios.get("/hemei-admin/villageInfo/pageList", { params });
    },
    // 乡村用户管理-用户列表
    userList(params) {
        return axios.get("/hemei-admin/villageBind/userList", { params });
    },


    // 获取乡村下拉列表
    getList(params) {
        return axios.get("/hemei-admin/villageInfo/getList", { params });
    },
    // 新增乡村管理员
    addVillageManage(data) {
        return axios.post("/hemei-admin/villageInfo/addVillageManage", data);
    },
    // 获取APP版本列表信息
    getAppVersionList(params) {
        return axios.get("/hemei-admin/appVersion/getAppVersionList", { params });
    },
    // 删除APP版本信息
    delAppVersion(params) {
        return axios.delete("/hemei-admin/appVersion/delAppVersion", { params });
    },
    // 新增、编辑APP版本信息
    saveOrUpdateAppVersion(data) {
        return axios.post("/hemei-admin/appVersion/saveOrUpdateAppVersion", data);
    },
    //  // 获取最新APP版本详情
    upload(data) {
        return axios.post("/service-app/file/upload", data);
    },
    // 更新乡村资料
    villageInfoDetailUpdate(data) {
        return axios.post("/hemei-admin/villageInfo/detail/update", data);
    },
    // 获取乡村下用户
    getVillageUserList(params) {
        return axios.get("hemei-admin/user/getVillageUserList", { params });
    },

    // 乡村搜索接口
    villageInfoSearch(params) {
        return axios.get("/hemei-admin/villageInfo/search", { params });
    },
    approvaldetail(params) {
        return axios.get("/hemei-admin/approval/workflow/bind/approval/detail", { params });
    },
    approvalsecretary(data) {
        return axios.post("/hemei-admin/approval/workflow/approval/secretary", data);
    },
    // 获取乡村申请审核详情页
    getVillageApplyInfoDetail(params) {
        return axios.get("/hemei-admin/villageApplyInfo/getVillageApplyInfoDetail", { params });
    },
    // 获取区域列表
    regionlist(params) {
        return axios.get("/hemei-admin/village/region/list", { params });
    },
}


export default info;


// WEBPACK FOOTER //
// ./src/api/info.js